
export class Constants {
    public static productInfo: string = "ProductInfo";
    public static uniqueId: string = "uid";
    public static site: string = "site";
    public static page: string = "pageUrl";
}